import { z } from 'zod';
import { ContractTableColumns, ContractType } from './-constants';
export const ContractTableFilterSchema = z.object({
  // ページネーション
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  // ソート
  sortColumn: z.nativeEnum(ContractTableColumns).optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
  // タブフィルタ
  contractType: z.nativeEnum(ContractType).default(ContractType.EMPLOYMENT),
  // フィルタ
  freeText: z.string().optional()
  // TODO: 検索フィルター作ってから利用
  // contractNo: z.string().optional(),
  // contractTitle: z.string().optional(),
  // contractStatus: z.nativeEnum(ContractStatus).optional(),
});